const dataMenu = [
    {
        iconUrl: '/images/home-icon.png',
        path: '/'
    },
    {
        iconUrl: '/images/color-icon.png',
        path: '/component/colorPage'
    },
    {
        iconUrl: '/images/tour-icon.png',
        path: '/component/touristPage'
    },
    {
        iconUrl: '/images/bedroom-icon.png',
        path: '/component/bedroomPage'
    },
    {
        iconUrl: '/images/food-icon.png',
        path: '/component/foodPage'
    },
    {
        iconUrl: '/images/house-icon.png',
        path: '/component/housePage'
    },
    {
        iconUrl: '/images/car-icon.png',
        path: '/component/carrPage'
    },
    {
        iconUrl: '/images/result-icon.png',
        path: '/component/successPage'
    },
]

export default dataMenu;